import React, { useState, useEffect,useCallback } from 'react';
import { toast } from 'react-toastify';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input } from 'reactstrap';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 12px;
    border: none;
  }
`;

const StyledModalHeader = styled(ModalHeader)`
  background: white;
  color: #7c3aed;
  border-bottom: none;
  padding: 24px 32px 16px 32px;
  
  .modal-title {
    font-size: 20px;
    font-weight: 600;
    color: #7c3aed;
  }
  
  .close {
    color: #9ca3af;
    opacity: 1;
    text-shadow: none;
    font-size: 28px;
    font-weight: 300;
    padding: 0;
    margin: 0;
    
    &:hover {
      color: #6b7280;
    }
  }
`;

const ConfirmationText = styled.div`
  font-size: 15px;
  color: #374151;
  margin-bottom: 20px;
  font-weight: 500;
`;

const StyledModalBody = styled(ModalBody)`
  padding: 16px 32px 24px 32px;
`;

const StyledFormGroup = styled(FormGroup)`
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledLabel = styled(Label)`
  font-weight: 600;
  color: #374151;
  font-size: 15px;
  margin-bottom: 0;
  margin-right: 16px;
  min-width: 120px;
  text-align: left;
`;

const StyledInput = styled(Input)`
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  color: #6b7280;
  flex: 1;
  
  &:focus {
    background-color: white;
    border-color: #7c3aed;
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
    outline: none;
  }
  
  &:disabled {
    background-color: #f3f4f6;
    cursor: not-allowed;
  }
`;

const StyledSelect = styled(Input)`
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 14px;
  color: #374151;
  flex: 1;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
  cursor: pointer;
  
  &:focus {
    background-color: white;
    border-color: #7c3aed;
    box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
    outline: none;
  }

  &.with-icon {
    background-image: 
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 9L1 4h10z'/%3E%3C/svg%3E"),
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2'%3E%3Crect x='3' y='4' width='18' height='18' rx='2' ry='2'%3E%3C/rect%3E%3Cline x1='16' y1='2' x2='16' y2='6'%3E%3C/line%3E%3Cline x1='8' y1='2' x2='8' y2='6'%3E%3C/line%3E%3Cline x1='3' y1='10' x2='21' y2='10'%3E%3C/line%3E%3C/svg%3E");
    background-position: right 12px center, right 36px center;
    padding-right: 60px;
  }

  &.with-time-icon {
    background-image: 
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236b7280' d='M6 9L1 4h10z'/%3E%3C/svg%3E"),
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%239ca3af' stroke-width='2'%3E%3Ccircle cx='12' cy='12' r='10'%3E%3C/circle%3E%3Cpolyline points='12 6 12 12 16 14'%3E%3C/polyline%3E%3C/svg%3E");
    background-position: right 12px center, right 36px center;
    padding-right: 60px;
  }
`;

const StyledModalFooter = styled(ModalFooter)`
  padding: 20px 32px 28px 32px;
  display: flex;
  justify-content: center;
  gap: 12px;
  border-top: none;
`;

const StyledButton = styled(Button)`
  border-radius: 8px;
  padding: 12px 48px;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.2s;
  min-width: 140px;
  
  &.btn-primary {
    background: linear-gradient(135deg, #7c3aed 0%, #6366f1 100%);
    border: none;
    box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3);
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(124, 58, 237, 0.4);
      background: linear-gradient(135deg, #6d28d9 0%, #5b21b6 100%);
    }

    &:active {
      transform: translateY(0);
    }
  }
  
  &.btn-secondary {
    background: white;
    color: #7c3aed;
    border: 2px solid #e5e7eb;
    
    &:hover {
      background: #f9fafb;
      color: #6d28d9;
      border-color: #d1d5db;
    }
  }
`;
const  centresAndDoctorsData1 = [
  {
    "centreId": "1",
    "centreName": "MyDental Plan",
    "doctors": [
      { "doctorId": "101", "doctorName": "Dr. Sourav Verma" },
      { "doctorId": "102", "doctorName": "Dr. Anu Joseph" }
    ]
  },
  {
    "centreId": "2",
    "centreName": "Manya Sector 70",
    "doctors": [
      { "doctorId": "201", "doctorName": "Dr. Rakesh Kumar" },
      { "doctorId": "202", "doctorName": "Dr. Priya Singh" }
    ]
  }
]
const data = [
  {
    "date": "2026-02-09",
    "slots": [
      { "slotId": 2, "slot": "08:00 AM" },
      { "slotId": 4, "slot": "02:00 PM" },
      { "slotId": 5, "slot": "05:00 PM" }
    ]
  },
  {
    "date": "2026-02-10",
    "slots": [
      { "slotId": 2, "slot": "08:00 AM" },
      { "slotId": 4, "slot": "02:00 PM" }
    ]
  }
]





const ChangeCentreModal = ({
  modalIsOpen,
  closeModal,
  submitModal,
  appointmentData,
  onComplete,
  centresAndDoctorsData = centresAndDoctorsData1,
  availableSlotsData = data,
  reasonOptions = ['Doctor not available', 'Patient requested', 'Centre not available', 'Other'],
}) => {
  const [selectedReason, setSelectedReason] = useState('');
  const [selectedCentreId, setSelectedCentreId] = useState('');
  const [selectedDoctorId, setSelectedDoctorId] = useState('');
  const [availableDoctors, setAvailableDoctors] = useState([]);
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedSlotId, setSelectedSlotId] = useState('');
  const [availableSlots, setAvailableSlots] = useState([]);

  const formatDateForDisplay = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  };

  const findNearestDate = (dates) => {
    if (!dates?.length) return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return (
      dates.find(d => {
        const date = new Date(d.date);
        date.setHours(0, 0, 0, 0);
        return date >= today;
      }) || dates[0]
    );
  };


  useEffect(() => {
    if (!modalIsOpen) {
      setSelectedReason('');
      setSelectedCentreId('');
      setSelectedDoctorId('');
      setAvailableDoctors([]);
      setSelectedDate('');
      setSelectedSlotId('');
      setAvailableSlots([]);
      return;
    }

    setSelectedReason(reasonOptions[0] || '');

    const firstCentre = centresAndDoctorsData[0];
    if (firstCentre) {
      setSelectedCentreId(firstCentre.centreId);
      setAvailableDoctors(firstCentre.doctors || []);
      setSelectedDoctorId(firstCentre.doctors?.[0]?.doctorId || '');
    }

    const nearestDate = findNearestDate(availableSlotsData);
    if (nearestDate) {
      setSelectedDate(nearestDate.date);
      setAvailableSlots(nearestDate.slots || []);
      setSelectedSlotId(nearestDate.slots?.[0]?.slotId || '');
    }
  }, [modalIsOpen]);

  /* -------- handlers -------- */

  const handleCentreChange = (e) => {
    const centreId = e.target.value;
    setSelectedCentreId(centreId);

    const centre = centresAndDoctorsData.find(c => c.centreId === centreId);
    setAvailableDoctors(centre?.doctors || []);
    setSelectedDoctorId(centre?.doctors?.[0]?.doctorId || '');
  };

  const handleDateChange = (e) => {
    const date = e.target.value;
    setSelectedDate(date);

    const dateObj = availableSlotsData.find(d => d.date === date);
    setAvailableSlots(dateObj?.slots || []);
    setSelectedSlotId(dateObj?.slots?.[0]?.slotId || '');
  };

  const handleConfirm = () => {
    if (!selectedReason) return toast.error('Please select a reason');
    if (!selectedCentreId) return toast.error('Please select a centre');
    if (!selectedDoctorId) return toast.error('Please select a doctor');
    if (!selectedDate) return toast.error('Please select a date');
    if (!selectedSlotId) return toast.error('Please select a time slot');

  const changeCentreData = {
  requestId: appointmentData ? appointmentData.rid : undefined,
  reason: selectedReason,
  newCentreId: selectedCentreId,
  newDoctorId: selectedDoctorId,
  newAppointmentDate: selectedDate,
  newAppointmentSlotId: Number(selectedSlotId),
};

if (submitModal) {
  submitModal(changeCentreData);
}

if (onComplete) {
  onComplete();
}

closeModal();


  };

  return (
    <StyledModal isOpen={modalIsOpen} toggle={closeModal}>
      <StyledModalHeader toggle={closeModal}>Change Centre</StyledModalHeader>

      <StyledModalBody>
        <ConfirmationText>Are you sure to change centre?</ConfirmationText>

        <StyledFormGroup>
          <StyledLabel>RID</StyledLabel>
          <StyledInput disabled value={appointmentData?.rid || ''} />
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Reason</StyledLabel>
          <StyledSelect type="select" value={selectedReason} onChange={e => setSelectedReason(e.target.value)}>
            {reasonOptions.map(r => (
              <option key={r} value={r}>{r}</option>
            ))}
          </StyledSelect>
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Centre</StyledLabel>
          <StyledSelect type="select" value={selectedCentreId} onChange={handleCentreChange}>
            {centresAndDoctorsData.map(c => (
              <option key={c.centreId} value={c.centreId}>{c.centreName}</option>
            ))}
          </StyledSelect>
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Doctor</StyledLabel>
          <StyledSelect type="select" value={selectedDoctorId} onChange={e => setSelectedDoctorId(e.target.value)}>
            {availableDoctors.map(d => (
              <option key={d.doctorId} value={d.doctorId}>{d.doctorName}</option>
            ))}
          </StyledSelect>
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Date</StyledLabel>
          <StyledSelect type="select" value={selectedDate} onChange={handleDateChange}>
            {availableSlotsData.map(d => (
              <option key={d.date} value={d.date}>{formatDateForDisplay(d.date)}</option>
            ))}
          </StyledSelect>
        </StyledFormGroup>

        <StyledFormGroup>
          <StyledLabel>Timing</StyledLabel>
          <StyledSelect type="select" value={selectedSlotId} onChange={e => setSelectedSlotId(e.target.value)}>
            {availableSlots.map(s => (
              <option key={s.slotId} value={s.slotId}>{s.slot}</option>
            ))}
          </StyledSelect>
        </StyledFormGroup>
      </StyledModalBody>

      <StyledModalFooter>
        <StyledButton color="primary" onClick={handleConfirm}>Confirm</StyledButton>
        <StyledButton color="secondary" onClick={closeModal}>Cancel</StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};

// const ChangeCentreModal = ({

//   modalIsOpen,
//   closeModal,
//   submitModal,
//   appointmentData,
//   onComplete,
//   // API 1: Centre and Doctor data
//   centresAndDoctorsData=centresAndDoctorsData1, // Array of { centreId, centreName, doctors: [{ doctorId, doctorName }] }
//   // API 2: Available slots data  
//   availableSlotsData = data, // Array of { date, slots: [{ slotId, slot }] }
//   reasonOptions = ['Doctor not available', 'Patient requested', 'Centre not available', 'Other'],
// }) => {
//   const [selectedReason, setSelectedReason] = useState('');
//   const [selectedCentreId, setSelectedCentreId] = useState('');
//   const [selectedDoctorId, setSelectedDoctorId] = useState('');
//   const [availableDoctors, setAvailableDoctors] = useState([]);
//   const [selectedDate, setSelectedDate] = useState('');
//   const [selectedSlotId, setSelectedSlotId] = useState('');
//   const [availableSlots, setAvailableSlots] = useState([]);

//   console.log("centresAndDoctorsData", centresAndDoctorsData);
//   console.log("availableSlotsData", availableSlotsData);

//   // Helper function to format date for display
//   const formatDateForDisplay = (dateString) => {
//     const date = new Date(dateString);
//     const options = { day: '2-digit', month: 'short', year: 'numeric' };
//     return date.toLocaleDateString('en-GB', options);
//   };

//   // Helper function to find nearest date
//   const findNearestDate = (dates) => {
//     if (!dates || dates.length === 0) return null;
    
//     const today = new Date();
//     today.setHours(0, 0, 0, 0);
    
//     const futureDates = dates.filter(dateObj => {
//       const date = new Date(dateObj.date);
//       date.setHours(0, 0, 0, 0);
//       return date >= today;
//     });
    
//     return futureDates.length > 0 ? futureDates[0] : dates[0];
//   };

//   // Reset values when modal opens
//   useEffect(() => {
//     if (modalIsOpen) {
//       console.log('Change Centre Modal opened - Resetting to defaults');
      
//       // Reset reason
//       setSelectedReason(reasonOptions[0]);
      
//       // Reset centre and doctor
//       if (centresAndDoctorsData && centresAndDoctorsData.length > 0) {
//         const firstCentre = centresAndDoctorsData[0];
//         setSelectedCentreId(firstCentre.centreId);
//         setAvailableDoctors(firstCentre.doctors || []);
        
//         if (firstCentre.doctors && firstCentre.doctors.length > 0) {
//           setSelectedDoctorId(firstCentre.doctors[0].doctorId);
//         } else {
//           setSelectedDoctorId('');
//         }
//       } else {
//         setSelectedCentreId('');
//         setSelectedDoctorId('');
//         setAvailableDoctors([]);
//       }
      
//       // Reset date and slot
//       if (availableSlotsData && availableSlotsData.length > 0) {
//         const nearestDateObj = findNearestDate(availableSlotsData);
        
//         if (nearestDateObj) {
//           setSelectedDate(nearestDateObj.date);
//           setAvailableSlots(nearestDateObj.slots || []);
          
//           if (nearestDateObj.slots && nearestDateObj.slots.length > 0) {
//             setSelectedSlotId(nearestDateObj.slots[0].slotId);
//           } else {
//             setSelectedSlotId('');
//           }
//         } else {
//           setSelectedDate('');
//           setAvailableSlots([]);
//           setSelectedSlotId('');
//         }
//       } else {
//         setSelectedDate('');
//         setAvailableSlots([]);
//         setSelectedSlotId('');
//       }
//     }
    
//     // Clear state when modal closes
//     if (!modalIsOpen) {
//       setSelectedReason('');
//       setSelectedCentreId('');
//       setSelectedDoctorId('');
//       setAvailableDoctors([]);
//       setSelectedDate('');
//       setSelectedSlotId('');
//       setAvailableSlots([]);
//     }
//   }, [modalIsOpen, centresAndDoctorsData, availableSlotsData, reasonOptions]);

//   // Handle centre change
//   const handleCentreChange = (e) => {
//     const newCentreId = e.target.value;
//     console.log('Centre changed to:', newCentreId);
//     setSelectedCentreId(newCentreId);
    
//     // Find doctors for selected centre
//     const centreData = centresAndDoctorsData.find(c => c.centreId === newCentreId);
//     if (centreData && centreData.doctors) {
//       setAvailableDoctors(centreData.doctors);
      
//       // Auto-select first doctor
//       if (centreData.doctors.length > 0) {
//         setSelectedDoctorId(centreData.doctors[0].doctorId);
//       } else {
//         setSelectedDoctorId('');
//       }
//     } else {
//       setAvailableDoctors([]);
//       setSelectedDoctorId('');
//     }
//   };

//   // Handle date change
//   const handleDateChange = (e) => {
//     const newDate = e.target.value;
//     console.log('Date changed to:', newDate);
//     setSelectedDate(newDate);
    
//     // Find slots for selected date
//     const dateData = availableSlotsData.find(d => d.date === newDate);
//     if (dateData && dateData.slots) {
//       setAvailableSlots(dateData.slots);
      
//       // Auto-select first slot
//       if (dateData.slots.length > 0) {
//         setSelectedSlotId(dateData.slots[0].slotId);
//       } else {
//         setSelectedSlotId('');
//       }
//     } else {
//       setAvailableSlots([]);
//       setSelectedSlotId('');
//     }
//   };

//   const handleConfirm = () => {
//     console.log('Confirm button clicked');
    
//     // Validation
//     if (!selectedReason) {
//       toast.error('Please select a reason');
//       return;
//     }

//     if (!selectedCentreId) {
//       toast.error('Please select a centre');
//       return;
//     }

//     if (!selectedDoctorId) {
//       toast.error('Please select a doctor');
//       return;
//     }

//     if (!selectedDate) {
//       toast.error('Please select a date');
//       return;
//     }

//     if (!selectedSlotId) {
//       toast.error('Please select a time slot');
//       return;
//     }

//     // Find selected centre, doctor, and slot details
//     const selectedCentre = centresAndDoctorsData.find(c => c.centreId === selectedCentreId);
//     const selectedDoctor = availableDoctors.find(d => d.doctorId === selectedDoctorId);
//     const selectedSlot = availableSlots.find(s => s.slotId === parseInt(selectedSlotId));

//     // Prepare data for submission
//     const changeCentreData = {
//       requestId: appointmentData?.rid,
//       reason: selectedReason,
//       newCentreId: selectedCentreId,
//       newCentreName: selectedCentre?.centreName,
//       newDoctorId: selectedDoctorId,
//       newDoctorName: selectedDoctor?.doctorName,
//       newAppointmentDate: selectedDate,
//       newAppointmentSlotId: parseInt(selectedSlotId),
//       newAppointmentSlot: selectedSlot?.slot,
//     };

//     console.log('Change centre data:', changeCentreData);

//     if (submitModal) {
//       submitModal(changeCentreData);
//     }
//     if (onComplete) {
//       onComplete();
//     }
//     closeModal();
//   };

//   return (
//     <StyledModal isOpen={modalIsOpen} toggle={closeModal} size="md">
//       <StyledModalHeader toggle={closeModal}>
//         <div className="modal-title">
//           Change Centre
//         </div>
//       </StyledModalHeader>
      
//       <StyledModalBody>
//         <ConfirmationText>
//           Are you sure to change centre?
//         </ConfirmationText>

//         {/* Read-only Display Fields */}
//         <StyledFormGroup>
//           <StyledLabel>RID:</StyledLabel>
//           <StyledInput
//             type="text"
//             value={appointmentData?.rid || ''}
//             disabled
//           />
//         </StyledFormGroup>

//         <StyledFormGroup>
//           <StyledLabel>Patient Name:</StyledLabel>
//           <StyledInput
//             type="text"
//             value={appointmentData?.patientName || ''}
//             disabled
//           />
//         </StyledFormGroup>

//         {/* Editable Fields */}
//         <StyledFormGroup>
//           <StyledLabel>Reason:</StyledLabel>
//           <StyledSelect
//             type="select"
//             value={selectedReason}
//             onChange={(e) => setSelectedReason(e.target.value)}
//           >
//             {reasonOptions.map((reason, index) => (
//               <option key={index} value={reason}>
//                 {reason}
//               </option>
//             ))}
//           </StyledSelect>
//         </StyledFormGroup>

//         <StyledFormGroup>
//           <StyledLabel>Centre:</StyledLabel>
//           <StyledSelect
//             type="select"
//             value={selectedCentreId}
//             onChange={handleCentreChange}
//           >
//             {centresAndDoctorsData && centresAndDoctorsData.length > 0 ? (
//               centresAndDoctorsData.map((centre) => (
//                 <option key={centre.centreId} value={centre.centreId}>
//                   {centre.centreName}
//                 </option>
//               ))
//             ) : (
//               <option value="">No centres available</option>
//             )}
//           </StyledSelect>
//         </StyledFormGroup>

//         <StyledFormGroup>
//           <StyledLabel>Doctor:</StyledLabel>
//           <StyledSelect
//             type="select"
//             value={selectedDoctorId}
//             onChange={(e) => setSelectedDoctorId(e.target.value)}
//           >
//             {availableDoctors.length > 0 ? (
//               availableDoctors.map((doctor) => (
//                 <option key={doctor.doctorId} value={doctor.doctorId}>
//                   {doctor.doctorName}
//                 </option>
//               ))
//             ) : (
//               <option value="">No doctors available</option>
//             )}
//           </StyledSelect>
//         </StyledFormGroup>

//         <StyledFormGroup>
//           <StyledLabel>Date:</StyledLabel>
//           <StyledSelect
//             type="select"
//             className="with-icon"
//             value={selectedDate}
//             onChange={handleDateChange}
//           >
//             {availableSlotsData && availableSlotsData.length > 0 ? (
//               availableSlotsData.map((dateObj, index) => (
//                 <option key={index} value={dateObj.date}>
//                   {formatDateForDisplay(dateObj.date)}
//                 </option>
//               ))
//             ) : (
//               <option value="">No dates available</option>
//             )}
//           </StyledSelect>
//         </StyledFormGroup>

//         <StyledFormGroup>
//           <StyledLabel>Timing:</StyledLabel>
//           <StyledSelect
//             type="select"
//             className="with-time-icon"
//             value={selectedSlotId}
//             onChange={(e) => setSelectedSlotId(e.target.value)}
//           >
//             {availableSlots.length > 0 ? (
//               availableSlots.map((slot) => (
//                 <option key={slot.slotId} value={slot.slotId}>
//                   {slot.slot}
//                 </option>
//               ))
//             ) : (
//               <option value="">No slots available</option>
//             )}
//           </StyledSelect>
//         </StyledFormGroup>
//       </StyledModalBody>
      
//       <StyledModalFooter>
//         <StyledButton color="primary" onClick={handleConfirm}>
//           Confirm
//         </StyledButton>
//         <StyledButton color="secondary" onClick={closeModal}>
//           Cancel
//         </StyledButton>
//       </StyledModalFooter>
//     </StyledModal>
//   );
// };

export default ChangeCentreModal;